export default __webpack_public_path__ + "static/media/ZEITStiftungBucerius_Logo_RGB.daa68ef5.png";